module.exports = "/images/vendor/flag-icon-css/flags/4x3/li.svg?fb5437d371f4dc6261e9f4e5bd21628d";